import script from "./LoadingBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingBox.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingBox.vue?vue&type=style&index=0&id=7ea812a2&lang=postcss&scoped=true"

import exportComponent from "/home/runner/work/matchd-frontend/matchd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ea812a2"]])

export default __exports__